import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handlePatch } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';
import { formatRFC3339WithOptions } from 'date-fns/fp';
import ErrorAwareNumberWithDcimalsField from '../../../common/inputfields/ErrorAwareNumberWithDecimalsField';

class ModifyRefuel extends Component {

    state = {
        privateId: null,
        refuelingAmountLiter: null,
        refuelingAmountForint: null,
        refuelingStation: null,
        refuelingBillPublicId: null,

        selectedRefuelingBill: {},

        selectedRefueling: null,
        refuelingBillId: null,

        errors: new Map(),
    }

    componentDidMount() {
        // console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/cardayrefuel';
        const requestObject = {
            "privateId": this.state.privateId,
            "carDayId": this.props.row.privateId,
            "refuelingAmountLiter": this.state.refuelingAmountLiter,
            "refuelingAmountForint": trimSpaces(this.state.refuelingAmountForint),
            "refuelingBillId": this.state.selectedRefuelingBill?.value
        };
        await handlePatch(path, requestObject, this);
    };


    promiseRefuelingBillsPromise = async () => {
        const params = {
            date: this.props.row.date
        }
        const response = await axios.get('/api/refuelbills', { params })
        return response.data.map(resp => ({
            label: `${resp.billNumber} - ${resp.customerName} - ${resp.amount} Ft`,
            value: resp.privateId
        }));
    };

    handleRefuelingBillSelected = (e, v) => {
        this.setState({ selectedRefuelingBill: v })
    }

    refuelingOptions = async () => {
        if (this.props.row.refuels) {
            return this.props.row.refuels.map(refuel => ({
                value: refuel.privateId,
                label: `${refuel.refuelingStation !== null ? refuel.refuelingStation : ''} Számla száma: ${refuel.refuelingBillPublicId !== null ? refuel.refuelingBillPublicId : 'nincs'} Liter: ${refuel.refuelingAmountLiter !== null ? refuel.refuelingAmountLiter : 'nincs'} Forint: ${refuel.refuelingAmountForint !== null ? refuel.refuelingAmountForint : 'nincs'}`,
                refuelingBillId: refuel.refuelingBillId,
                refuelingAmountLiter: refuel.refuelingAmountLiter,
                refuelingAmountForint: refuel.refuelingAmountForint,
                refuelingStation: refuel.refuelingStation,
                refuelingBillPublicId: refuel.refuelingBillPublicId,
                privateId: refuel.privateId
            }));
        }
        return [];
    };

    handleRefuelingSelected = (e, v) => {
        console.log(v);
        this.setState({
            selectedRefueling: v, refuelingAmountLiter: v.refuelingAmountLiter, refuelingAmountForint: v.refuelingAmountForint, refuelingBillId: v.refuelingBillId, privateId: v.privateId,
            refuelingBillPublicId: v.refuelingBillPublicId, refuelingStation: v.refuelingStation
        })
        const bill = {
            label: `${v.refuelingBillPublicId} - ${v.refuelingStation}`,
            value: v.refuelingBillId
        }
        this.setState({ selectedRefuelingBill: bill })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group-1'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedRefueling}
                            defaultvale={this.state.selectedRefueling}
                            getOptions={this.refuelingOptions}
                            onChange={this.handleRefuelingSelected}
                            label={'Tankolás'}
                            required={true}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="licenseNumber"
                            label="Rendszám"
                            errors={this.state.errors}
                            value={this.props.row.licenseNumber}
                            disabled
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            id="date"
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            disabled
                            onChange={v => handleChangeValue(v, "date", this)}
                        />
                    </div>
                    {this.state.selectedRefueling &&
                        <>
                            <div className='input-group'>
                                <ErrorAwareNumberWithDcimalsField
                                    name="refuelingAmountLiter"
                                    label="Tankolt liter"
                                    errors={this.state.errors}
                                    value={this.state.refuelingAmountLiter}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group'>
                                <ErrorAwareAmountField
                                    name="refuelingAmountForint"
                                    label="Tankolt összeg"
                                    errors={this.state.errors}
                                    value={this.state.refuelingAmountForint}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-1'>
                                <MyCreatableAutocomplete
                                    value={this.state.selectedRefuelingBill}
                                    defaultvale={this.state.selectedRefuelingBill}
                                    getOptions={this.promiseRefuelingBillsPromise}
                                    onChange={this.handleRefuelingBillSelected}
                                    label={'Számla száma'}
                                    required={false}
                                />
                            </div>
                        </>}
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosítás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyRefuel);
